// extracted by mini-css-extract-plugin
export default {"refresh-data-btn":"styles_refresh-data-btn__PIUWL","loader":"styles_loader__asHub","rotateClockwise":"styles_rotateClockwise__1bGd6"};